import React, { Component } from 'react';
import Input from 'components/Input';

import 'sass/components/student-notes.scss';

export default class StudentNotes extends Component {

    constructor (props) {
        super(props);

        this.state = {
            notes: this.props.student.notes
        };
    }

    notesChanged(event){
        this.setState({
            notes: event.target.value
        });
        this.props.updateNotes(this.props.student, event.target.value);
    }

    render () {
        return (
            <div className="student-notes">
                <Input
                    placeholder="Notes"
                    type="textarea"
                    name="Notes"
                    value={this.state.notes}
                    onChange={this.notesChanged.bind(this)}
                />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./js/components/StudentNotes.js